import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import { passwordChecklist } from '../validation/password';

/**
 * Live "rules satisfied" checklist rendered under each new-password
 * field. Each rule lights up the moment its condition is met so the
 * user sees what's left to do rather than being told what's wrong
 * only on submit. Kept here as a shared component so Register,
 * ResetPassword, and AcceptInvite stay in lock-step — if the policy
 * changes, `validation/password.ts` is the only edit.
 */
export function PasswordRulesHint({ value }: { value: string }) {
  const rules = passwordChecklist(value);
  return (
    <Stack spacing={0.25} sx={{ mt: 0.5 }} aria-live="polite">
      {rules.map((rule) => (
        <Box
          key={rule.label}
          sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}
        >
          {rule.ok ? (
            <CheckCircleIcon fontSize="small" color="success" />
          ) : (
            <RadioButtonUncheckedIcon
              fontSize="small"
              sx={{ color: 'text.disabled' }}
            />
          )}
          <Typography
            variant="caption"
            color={rule.ok ? 'success.main' : 'text.secondary'}
          >
            {rule.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
